import React, { useState } from 'react';
import ImageHTML from '../imgenHTML/ImageHTML';
import SinResultados from '../sinResultados/SinResultados';
import { dateFormatDDmesAnio } from '../../functions/functions';
import { PATHURLDOMAIN } from '../../constantes/constantes';

export default function Resultados({ data, query }) {

  const [dataQ, setDataQ] = useState(data);

  const sendMessageToParent = (data) => {
    window.parent.postMessage({ type: 'tageo', data }, PATHURLDOMAIN);
  };
  
  // Ejemplo de uso: enviar un mensaje cuando se haga clic en un botón
  const handleButtonClick = (e,item) => {
    // e.preventDefault();
    sendMessageToParent({ event: 'click', data: item });
  };

  
  return (
    <>
      {!dataQ || !dataQ.hits || dataQ.hits.length === 0
        ? <SinResultados query={query}/>
        :
        <div id="resultados">
          {dataQ.hits.map((item, id) => (
            <div key={item.title + " - "+ id} className="amx-notas-homes">
              <a className="item" href={item.url} title={item.title} target="_parent" onClick={(e)=>handleButtonClick(e,item)}>
                <div className="thumb">
                  {item.tags && item.tags.includes("video") && <span className="amx-icon-play"></span>}
                  <ImageHTML  url={item.image} title={item.title} />
                </div>
                
                <div className="info">
                  <h4>{(item.subcategory ? item.subcategory : item.category).replace(/-/g, ' ')}</h4>
                  <h3>{item.title}</h3>
                  <time dateTime={item.date} className="datetime">{dateFormatDDmesAnio(item.date)}</time>
                </div>
              </a>
            </div>
          ))}
        </div>
      }
    </>
  );
}